import { format, parseISO } from 'date-fns';
import formatCurrency from 'syf-js-utilities/formats/formatCurrency';
import i18n from '../strings/i18n';
import { getNumberOfDaysToScheduledPayment, numberOfDaysToDueDate } from './activityHelpers';
var FAS_ICON_TYPE = 'fas';
var NOTIFICATION_NAMES = {
    PAST_DUE: 'pastDueNotify',
    PAYMENT_DUE_TODAY: 'paymentDueTodayNotify',
    PAYMENT_DUE_TOMMOROW: 'paymentDueTomorrowNotify',
    PAYMENT_DUE_FUTURE: 'paymentDueFutureNotify',
    NO_PAYMENT_DUE: 'noPaymentDueNotify',
    PAYMENT_SCHEDULED_TODAY: 'paymentScheduledTodayNotify',
    PAYMENT_SCHEDULED_TOMORROW: 'paymentScheduledTomorrowNotify',
    PAYMENT_SCHEDULED_FUTURE: 'paymentScheduledFutureNotify',
    PAYMENT_PROCESSING: 'paymentProcessingNotify',
    AUTOPAY_TODAY: 'autopayTodayNotify',
    AUTOPAY_TOMORROW: 'autopayTomorrowNotify',
    AUTOPAY_FUTURE: 'autopayFutureNotify',
    LOAN_PAID_OFF: 'loanPaidOffNotify',
    REGISTER_ACCOUNT: 'registerAccountNotify',
    ENROLLED_PAYMENT_PLAN: 'enrolledPaymentPlan',
    CLOSED_WITH_BALANCE: 'closedWithBalanceNotify',
    ATTENTION_REQUIRED: 'attentionRequiredNotify',
    WAIVED_INTEREST_EXPIRING: 'waivedInterestExpiringNotify',
    INTRO_RATE_LOAN_EXPIRING: 'introRateLoanExpiredNotify',
    LOAN_APPROVED_STILL_PROCESSING: 'loanApprovedStillProcessingNotify'
};
export var PEAKS_UPAG_ALLOWED_NOTIFICATIONS = new Set([
    NOTIFICATION_NAMES.NO_PAYMENT_DUE,
    NOTIFICATION_NAMES.PAYMENT_PROCESSING,
    NOTIFICATION_NAMES.PAST_DUE,
    NOTIFICATION_NAMES.PAYMENT_DUE_TODAY,
    NOTIFICATION_NAMES.PAYMENT_DUE_TOMMOROW,
    NOTIFICATION_NAMES.PAYMENT_DUE_FUTURE,
    NOTIFICATION_NAMES.PAYMENT_SCHEDULED_TODAY,
    NOTIFICATION_NAMES.PAYMENT_SCHEDULED_TOMORROW,
    NOTIFICATION_NAMES.PAYMENT_SCHEDULED_FUTURE,
    NOTIFICATION_NAMES.AUTOPAY_TODAY,
    NOTIFICATION_NAMES.AUTOPAY_TOMORROW,
    NOTIFICATION_NAMES.AUTOPAY_FUTURE
]);
export var pastDueStatus = function () { return ({
    name: NOTIFICATION_NAMES.PAST_DUE,
    description: i18n({ notifications: NOTIFICATION_NAMES.PAST_DUE }),
    subDescription: i18n({ notifications: 'pastDueNotifyMessage' }),
    notificationType: 'warning',
    notificationIcon: 'circle-exclamation',
    fontAwesomeType: FAS_ICON_TYPE
}); };
export var currentPaymentDueStatus = function () { return ({
    name: NOTIFICATION_NAMES.PAYMENT_DUE_TODAY,
    description: i18n({
        notifications: NOTIFICATION_NAMES.PAYMENT_DUE_TODAY
    }),
    notificationType: 'warning',
    notificationIcon: 'circle-exclamation',
    fontAwesomeType: FAS_ICON_TYPE
}); };
export var futurePaymentDueStatus = function (date) {
    var daysToDueDate = numberOfDaysToDueDate(date);
    var name = daysToDueDate === 1
        ? NOTIFICATION_NAMES.PAYMENT_DUE_TOMMOROW
        : NOTIFICATION_NAMES.PAYMENT_DUE_FUTURE;
    return {
        name: name,
        description: i18n({ notifications: name }, {
            numberOfDaysToDueDate: daysToDueDate
        }),
        notificationType: 'info',
        notificationIcon: 'calendar-day'
    };
};
var getScheduledPaymentStatusName = function (daysToDueDate) {
    switch (daysToDueDate) {
        case 0:
            return NOTIFICATION_NAMES.PAYMENT_SCHEDULED_TODAY;
        case 1:
            return NOTIFICATION_NAMES.PAYMENT_SCHEDULED_TOMORROW;
        default:
            return NOTIFICATION_NAMES.PAYMENT_SCHEDULED_FUTURE;
    }
};
export var paymentScheduledStatus = function (activity, daysToDueDate, isPayLaterAccount) {
    var payAmount = Math.abs(Number(activity === null || activity === void 0 ? void 0 : activity.amount));
    var name = !isPayLaterAccount
        ? getScheduledPaymentStatusName(daysToDueDate)
        : NOTIFICATION_NAMES.PAYMENT_SCHEDULED_FUTURE;
    return {
        name: name,
        description: i18n({ notifications: name }, {
            payAmount: formatCurrency(payAmount),
            numberOfDaysToDueDate: daysToDueDate
        }),
        notificationType: 'success',
        notificationIcon: 'calendar-day'
    };
};
export var noPaymentDueStatus = function () { return ({
    name: NOTIFICATION_NAMES.NO_PAYMENT_DUE,
    description: i18n({ notifications: NOTIFICATION_NAMES.NO_PAYMENT_DUE }),
    notificationType: 'success',
    fontAwesomeType: FAS_ICON_TYPE,
    notificationIcon: 'circle-check'
}); };
var getAutoPaymentStatusName = function (daysToDueDate) {
    switch (daysToDueDate) {
        case 0:
            return NOTIFICATION_NAMES.AUTOPAY_TODAY;
        case 1:
            return NOTIFICATION_NAMES.AUTOPAY_TOMORROW;
        default:
            return NOTIFICATION_NAMES.AUTOPAY_FUTURE;
    }
};
export var autopayScheduledStatus = function (amount, daysToDueDate) {
    var minAmountDue = Math.abs(Number(amount));
    var name = getAutoPaymentStatusName(daysToDueDate);
    return {
        name: name,
        description: i18n({
            notifications: name
        }, {
            minAmountDue: formatCurrency(minAmountDue),
            daysToDueDate: daysToDueDate
        }),
        notificationType: 'success',
        notificationIcon: 'sync'
    };
};
export var getScheduledPaymentStatus = function (scheduledActivities, isPayLaterAccount) {
    return scheduledActivities
        ? scheduledActivities.map(function (activity) {
            var daysToDueDate = getNumberOfDaysToScheduledPayment(activity);
            if (daysToDueDate >= 0) {
                return paymentScheduledStatus(activity, daysToDueDate, isPayLaterAccount);
            }
            return null;
        })
        : [];
};
export var getPaymentProcessingStatus = function (processingActivities) {
    return processingActivities.map(function (_a) {
        var amount = _a.amount;
        return {
            name: NOTIFICATION_NAMES.PAYMENT_PROCESSING,
            description: i18n({
                notifications: NOTIFICATION_NAMES.PAYMENT_PROCESSING
            }, {
                amountPaid: formatCurrency(Math.abs(Number(amount)))
            }),
            notificationType: 'info',
            notificationIcon: 'spinner'
        };
    });
};
export var loanPaidOffStatus = function () { return ({
    name: NOTIFICATION_NAMES.LOAN_PAID_OFF,
    description: i18n({ notifications: NOTIFICATION_NAMES.LOAN_PAID_OFF }),
    notificationType: 'success',
    notificationIcon: 'circle-check',
    fontAwesomeType: FAS_ICON_TYPE
}); };
export var registerAccountStatus = function () { return ({
    name: NOTIFICATION_NAMES.REGISTER_ACCOUNT,
    description: i18n({ notifications: NOTIFICATION_NAMES.REGISTER_ACCOUNT }),
    notificationType: 'warning',
    notificationIcon: 'circle-exclamation',
    fontAwesomeType: FAS_ICON_TYPE
}); };
export var enrolledOnPaymentPlanStatus = function () { return ({
    name: NOTIFICATION_NAMES.ENROLLED_PAYMENT_PLAN,
    description: i18n({
        notifications: NOTIFICATION_NAMES.ENROLLED_PAYMENT_PLAN
    }),
    notificationType: 'success',
    notificationIcon: 'circle-check',
    fontAwesomeType: FAS_ICON_TYPE
}); };
export var closedWithBalanceStatus = function () { return ({
    name: NOTIFICATION_NAMES.CLOSED_WITH_BALANCE,
    description: i18n({ notifications: 'closedWithBalance' }),
    notificationType: 'info',
    notificationIcon: 'store-alt-slash'
}); };
export var attentionRequiredStatus = function () { return ({
    name: NOTIFICATION_NAMES.ATTENTION_REQUIRED,
    description: i18n({ notifications: 'attentionRequired' }),
    subDescription: "".concat(i18n({ notifications: 'issueWithAccount' }), " \n   "),
    notificationType: 'warning',
    notificationIcon: 'circle-exclamation',
    fontAwesomeType: FAS_ICON_TYPE
}); };
export var waivedInterestExpiringNotification = function (waivedInterest) {
    var promoEndDate = format(parseISO(waivedInterest === null || waivedInterest === void 0 ? void 0 : waivedInterest.promoEndDate), 'MM/dd/yyyy');
    return {
        name: NOTIFICATION_NAMES.WAIVED_INTEREST_EXPIRING,
        description: i18n({ notifications: 'promotionExpiring' }),
        subDescription: i18n({ notifications: 'waivedInterestPromotionExpiring' }, {
            payOffBalance: waivedInterest === null || waivedInterest === void 0 ? void 0 : waivedInterest.payOffBalance,
            promoEndDate: promoEndDate
        }),
        notificationType: 'warning',
        notificationIcon: 'circle-exclamation',
        fontAwesomeType: FAS_ICON_TYPE
    };
};
export var waivedInterestExpiredNotification = function () { return ({
    name: NOTIFICATION_NAMES.WAIVED_INTEREST_EXPIRING,
    description: i18n({ notifications: 'promotionExpired' }),
    subDescription: i18n({ notifications: 'waivedInterestPromotionExpired' }),
    notificationType: 'warning',
    notificationIcon: 'circle-exclamation',
    fontAwesomeType: FAS_ICON_TYPE
}); };
export var introRateLoanExpiredNotification = function () { return ({
    name: NOTIFICATION_NAMES.INTRO_RATE_LOAN_EXPIRING,
    description: i18n({ notifications: 'introRateLoanExpired' }),
    subDescription: i18n({ notifications: 'introRateLoanPromotionExpired' }),
    notificationType: 'warning',
    notificationIcon: 'circle-exclamation',
    fontAwesomeType: FAS_ICON_TYPE
}); };
export var introRateLoanExpiringNotification = function (introRateLoan) {
    var promoExpiryDate = format(parseISO(introRateLoan === null || introRateLoan === void 0 ? void 0 : introRateLoan.promoExpiryDate), 'MM/dd/yyyy');
    return {
        name: NOTIFICATION_NAMES.INTRO_RATE_LOAN_EXPIRING,
        description: i18n({ notifications: 'introRateLoanExpiring' }),
        subDescription: i18n({ notifications: 'introRateLoanPromotionExpiring' }, {
            promoExpiryDate: promoExpiryDate
        }),
        notificationType: 'warning',
        notificationIcon: 'circle-exclamation',
        fontAwesomeType: FAS_ICON_TYPE
    };
};
export var loanApprovedStillProcessingNotification = function () { return ({
    name: NOTIFICATION_NAMES.LOAN_APPROVED_STILL_PROCESSING,
    description: i18n({ notifications: 'loanApprovedStillProcessing' }),
    notificationType: 'warning',
    notificationIcon: 'circle-exclamation',
    fontAwesomeType: FAS_ICON_TYPE
}); };
